module.exports = __webpack_public_path__ + "img/组10972@3x.09f87eba.png";